import {
    FETCH_NEWS_FEED_COMMENT_LIKES_START,
    FETCH_NEWS_FEED_COMMENT_LIKES_SUCCESS,
    FETCH_NEWS_FEED_COMMENT_LIKES_FAIL,
    ADD_NEWS_FEED_COMMENT_LIKE_START,
    ADD_NEWS_FEED_COMMENT_LIKE_SUCCESS,
    ADD_NEWS_FEED_COMMENT_LIKE_FAIL,
    REMOVE_NEWS_FEED_COMMENT_LIKE_START,
    REMOVE_NEWS_FEED_COMMENT_LIKE_SUCCESS,
    REMOVE_NEWS_FEED_COMMENT_LIKE_FAIL,
    FETCH_NEWS_FEED_CONVERSATION_LIKES_START,
    FETCH_NEWS_FEED_CONVERSATION_LIKES_SUCCESS,
    FETCH_NEWS_FEED_CONVERSATION_LIKES_FAIL,
    RESET_NEWS_FEED_LIKES
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    commentLikes: [],
    commentLikesFetching: false,
    commentLikesFetchSuccess: false,
    commentLikesFetchFail: false,
    commentLikeUpdating: {},
    commentLikeUpdateSuccess: false,
    commentLikeUpdateFail: false,
    conversationLikes: [],
    conversationLikesFetching: false,
    conversationLikesFetchSuccess: false,
    conversationLikesFetchFail: false
};

const commentLikesFetching = (state, { reset }) => ({
    ...state,
    commentLikes: reset ? [] : state.commentLikes,
    commentLikesFetching: true,
    commentLikesFetchSuccess: false,
    commentLikesFetchFail: false
});

const commentLikeUpdating = (state, { commentUuid }) => ({
    ...state,
    commentLikeUpdating: {
        ...state.commentLikeUpdating,
        [commentUuid]: true
    }
});

const commentLikeUpdateFinished = (isSuccess) => (state, { commentUuid }) => ({
    ...state,
    commentLikeUpdating: {
        ...state.commentLikeUpdating,
        [commentUuid]: false
    },
    commentLikeUpdateSuccess: isSuccess,
    commentLikeUpdateFail: !isSuccess
});

const conversationLikesFetching = (state, { reset }) => ({
    ...state,
    conversationLikes: reset ? [] : state.conversationLikes,
    conversationLikesFetching: true,
    conversationLikesFetchSuccess: false,
    conversationLikesFetchFail: false
});

const commentLikesFetchFinished = (isSuccess) => (state, { data }) => {
    let newCommentLikes;
    if (isSuccess) {
        if (state.commentLikes.length > 0) {
            newCommentLikes = state.commentLikes.concat(data);
        } else {
            newCommentLikes = data;
        }
    }

    return {
        ...state,
        commentLikes: isSuccess ? newCommentLikes : state.commentLikes,
        commentLikesFetching: false,
        commentLikesFetchSuccess: isSuccess,
        commentLikesFetchFail: !isSuccess
    };
};

const conversationLikesFetchFinished = (isSuccess) => (state, { data }) => {
    let newConversationLikes;
    if (isSuccess) {
        if (state.conversationLikes.length > 0) {
            newConversationLikes = state.conversationLikes.concat(data);
        } else {
            newConversationLikes = data;
        }
    }

    return {
        ...state,
        conversationLikes: isSuccess ? newConversationLikes : state.conversationLikes,
        conversationLikesFetching: false,
        conversationLikesFetchSuccess: isSuccess,
        conversationLikesFetchFail: !isSuccess
    };
};

const resetNewsFeedLikes = () => {
    return INITIAL_STATE;
};

const handlers = {
    [FETCH_NEWS_FEED_COMMENT_LIKES_START]: commentLikesFetching,
    [FETCH_NEWS_FEED_COMMENT_LIKES_SUCCESS]: commentLikesFetchFinished(true),
    [FETCH_NEWS_FEED_COMMENT_LIKES_FAIL]: commentLikesFetchFinished(false),
    [ADD_NEWS_FEED_COMMENT_LIKE_START]: commentLikeUpdating,
    [ADD_NEWS_FEED_COMMENT_LIKE_SUCCESS]: commentLikeUpdateFinished(true),
    [ADD_NEWS_FEED_COMMENT_LIKE_FAIL]: commentLikeUpdateFinished(false),
    [REMOVE_NEWS_FEED_COMMENT_LIKE_START]: commentLikeUpdating,
    [REMOVE_NEWS_FEED_COMMENT_LIKE_SUCCESS]: commentLikeUpdateFinished(true),
    [REMOVE_NEWS_FEED_COMMENT_LIKE_FAIL]: commentLikeUpdateFinished(false),
    [FETCH_NEWS_FEED_CONVERSATION_LIKES_START]: conversationLikesFetching,
    [FETCH_NEWS_FEED_CONVERSATION_LIKES_SUCCESS]: conversationLikesFetchFinished(true),
    [FETCH_NEWS_FEED_CONVERSATION_LIKES_FAIL]: conversationLikesFetchFinished(false),
    [RESET_NEWS_FEED_LIKES]: resetNewsFeedLikes
};

export const getCommentLikesFetching = (state) => state.newsFeedLikes.commentLikesFetching;
export const getCommentLikesFetchSuccess = (state) => state.newsFeedLikes.commentLikesFetchSuccess;
export const getCommentLikeUpdating = (state, commentUuid) =>
    state.newsFeedLikes.commentLikeUpdating && state.newsFeedLikes.commentLikeUpdating[commentUuid];

export const getConversationLikesFetching = (state) => state.newsFeedLikes.conversationLikesFetching;
export const getConversationLikesFetchSuccess = (state) => state.newsFeedLikes.conversationLikesFetchSuccess;

export const getCommentLikes = (state) => state.newsFeedLikes && state.newsFeedLikes.commentLikes;
export const getConversationLikes = (state) => state.newsFeedLikes && state.newsFeedLikes.conversationLikes;
export const getShowLikeFailedDialog = (state) => state.newsFeedLikes.showLikeFailedDialog;

export default function newsFeedLikes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
